import { downloadBinary } from "@rootreeweb/js-lib";

import type { IAjaxObj } from "../types";

declare const RTAdminAjax: IAjaxObj;

/** Initializes the colour swatch generator page. */
export function initColours(): void {
	const swatchButton = document.getElementById(
		"rt-colour-swatch-generator-button",
	);
	swatchButton?.addEventListener("click", handleClick);
}

/** Handles the click event for the colour swatch generator button. */
async function handleClick() {
	const nonceElement = document.querySelector(
		"#rt-colour-swatch-generator-nonce",
	);
	if (!nonceElement || !(nonceElement instanceof HTMLInputElement)) {
		console.error("Nonce element not found or invalid type.");
		return;
	}

	const nonce = nonceElement.value;

	const response = await fetch(RTAdminAjax.ajaxurl, {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		body: `action=colours_get_pallet&_wpnonce=${nonce}`,
	});
	if (!response.ok) {
		console.error("Failed to get ASE.");
		return;
	}
	const arrayBuffer = await response.arrayBuffer();
	downloadBinary("rootree-colours.ase", arrayBuffer);
}
